import { useState, useEffect } from "react";
import { Button, message, Select, Space, Tooltip } from "antd";
import axios from "axios";
import "../css/loadprint.css";
import { update_print_cc, HEADERS_BASIC90 } from "../api/apiCent90";
import { createPdfRePrintAcc1 as printPDF1 } from "../pdf/new/ExportRePrintAcc1";
import { createPdfRePrintAcc2And8 as printPDF28 } from "../pdf/new/ExportRePrintAcc2And8";
import { createPdfRePrintAcc3 as printPDF3 } from "../pdf/new/ExportRePrintAcc3";
// import { createPdfRePrintAcc1 } from "../pdf/ExportRePrintAcc1";
// import { createPdfRePrintAcc3 } from "../pdf/ExportRePrintAcc3";

// ตัวเลือกทนาย (ใช้สลับลายเซ็นตอนพิมพ์)
const lawyerOptions = [
  { value: "sakon", label: "ทนายสกล" },
  { value: "pongsara", label: "ทนายแรมโบ้" },
];

function PrintPDF({ dataTabelB, roundDate, schemaSelected = false }) {
  const [batchIndex, setBatchIndex] = useState(0);
  const [printing, setPrinting] = useState(false);
  const [jobProgress, setJobProgress] = useState({ current: 0, total: 0 }); // ✅ ใหม่: โชว์ความคืบหน้าระดับ job (schema x batch) แทน currentBatchNumber เดิม
  // เลือกทนายก่อนพิมพ์ (บังคับเลือก ไม่มีค่า default)
  const [selectedLawyer, setSelectedLawyer] = useState(null);

  // ต้องเลือกประเภทสัญญาก่อน ถึงจะเลือกทนายได้ — ถ้ายกเลิกประเภท ให้ล้างทนายด้วย
  useEffect(() => {
    if (!schemaSelected) setSelectedLawyer(null);
  }, [schemaSelected]);

  const batchSize = 200; // ✅ แบ่งชุดละ 200

  const handlePDF = async () => {
    handleExport();
  };

  const triggerPrintWindow = (blobUrl) => {
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.top = "-9999px";
    iframe.style.left = "-9999px";
    iframe.style.width = "1000px";
    iframe.style.height = "1000px";
    iframe.style.border = "0";

    document.body.appendChild(iframe);

    iframe.onload = () => {
      const win = iframe.contentWindow;
      win.focus();
      win.print();

      // ตั้งเวลาลบ iframe ทิ้ง (เผื่อไว้ 5 นาทีค่อยลบ เพื่อไม่ให้ error ตอนปริ้น)
      setTimeout(() => {
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe);
        }
      }, 300000);
    };

    iframe.src = blobUrl;
  };

  const handleExport = async () => {
    if (!dataTabelB?.length) return;
    if (!selectedLawyer) {
      message.warning("กรุณาเลือกทนายก่อนพิมพ์");
      return;
    }

    setPrinting(true);

    // ✅ แก้ที่ 1: Group ข้อมูลตาม contractSchema ก่อน แทนที่จะ slice ทับไปตามลำดับเดิมของ dataTabelB
    // เหตุผล: ถ้าข้อมูลมีหลายประเภทสัญญาปนกัน (เช่น lsfhp, rpsl, vsfhp ปนกันใน dataTabelB)
    // การ slice ทับไปตามลำดับเดิมจะทำให้ 1 batch มีข้อมูลหลายประเภทปนกัน
    const grouped = dataTabelB.reduce((acc, item) => {
      const key = item.contractSchema || "unknown";
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});

    // ✅ แก้ที่ 2: แบ่ง batch แยกภายในแต่ละกลุ่ม schema แล้วรวมเป็น job list เดียว
    // ทำให้ทุก batch การันตีว่ามีข้อมูล schema เดียวกันทั้งหมด ไม่ปนกัน
    const jobs = [];
    Object.entries(grouped).forEach(([schemaKey, groupData]) => {
      const totalBatchesInGroup = Math.ceil(groupData.length / batchSize);
      for (let i = 0; i < totalBatchesInGroup; i++) {
        jobs.push({
          schemaKey,
          batchData: groupData.slice(i * batchSize, (i + 1) * batchSize),
          totalCount: groupData.length, // จำนวนรวมของ schema นี้ (ไม่ปนกับ schema อื่น)
          startOffset: i * batchSize,
        });
      }
    });

    setJobProgress({ current: 0, total: jobs.length });

    try {
      for (let j = 0; j < jobs.length; j++) {
        const { schemaKey, batchData, totalCount, startOffset } = jobs[j];

        console.log("printing job", j + 1, "of", jobs.length, "schemaKey:", schemaKey, "count:", batchData.length);

        setJobProgress({ current: j + 1, total: jobs.length });

        let blobUrl;

        // ✅ แก้ที่ 3: เทียบ schemaKey เป็น string ตรง ๆ (contractSchema เป็น string เช่น "lsfhp" ไม่ใช่ object ที่มี .key)
        if (schemaKey === "lsfhp") {
          blobUrl = await printPDF1(batchData, schemaKey, totalCount, startOffset, selectedLawyer);
        } else if (schemaKey === "psfhp" || schemaKey === "rpsl") {
          blobUrl = await printPDF3(batchData, schemaKey, totalCount, startOffset, selectedLawyer);
        } else {
          blobUrl = await printPDF28(batchData, schemaKey, totalCount, startOffset, selectedLawyer);
        }

        // สั่งปริ้น
        triggerPrintWindow(blobUrl);

        // ✅ บันทึก date_print ตอนสั่งพิมพ์ (ครั้งเดียวต่อ schema = ตอนเปิดพิมพ์ชุดแรกของ schema นั้น)
        const isFirstOfSchema = j === 0 || jobs[j - 1].schemaKey !== schemaKey;
        if (isFirstOfSchema) {
          // ✅ แยก try/catch เฉพาะการบันทึกสถานะพิมพ์ ไม่ให้ล้มทั้งกระบวนการพิมพ์
          // (สั่ง triggerPrintWindow ไปแล้วด้านบน) ถ้า call นี้พลาด เช่น 404 ให้เตือนแล้วไปต่อ
          try {
            await axios.post(
              update_print_cc,
              {
                date: roundDate,
                contractSchema: schemaKey,
                user: localStorage.getItem("USERNAME"),
              },
              { headers: HEADERS_BASIC90 },
            );
            message.success(`บันทึกสถานะพิมพ์ (${schemaKey}) เรียบร้อย`);
          } catch (err) {
            console.error("update-print-cc failed:", err);
            message.warning(
              `พิมพ์ (${schemaKey}) แล้ว แต่บันทึกสถานะพิมพ์ไม่สำเร็จ: ${err.message}`,
            );
          }
        }

        const isLastJob = j === jobs.length - 1;

        if (!isLastJob) {
          // รอ 1 วินาที ให้หน้าต่าง Print เด้งขึ้นมาให้เรียบร้อยก่อน
          await new Promise((r) => setTimeout(r, 1000));

          // วนลูปเช็คทุก 1 วินาที จนกว่า User จะปิดหน้าต่าง Print (Focus กลับมาที่หน้าเว็บ)
          await new Promise((resolve) => {
            const checkInterval = setInterval(() => {
              if (document.hasFocus()) {
                clearInterval(checkInterval);
                resolve();
              }
            }, 1000);
          });

          // พักอีกนิดนึง (0.5วิ) เพื่อความชัวร์ว่า Browser เคลียร์ Dialog หมดแล้วจริงๆ
          await new Promise((r) => setTimeout(r, 500));

          const msg = `พิมพ์ชุดที่ ${j + 1}/${jobs.length} (${schemaKey}) เสร็จเรียบร้อย\nกด OK เพื่อพิมพ์ชุดถัดไป`;
          const userClickedOK = window.confirm(msg);

          URL.revokeObjectURL(blobUrl);

          if (!userClickedOK) {
            break;
          }
        } else {
          // รอบสุดท้าย รอแป๊บเดียวแล้วจบเลย
          await new Promise((r) => setTimeout(r, 2000));
          URL.revokeObjectURL(blobUrl);
        }
      }
    } catch (error) {
      console.error("Error:", error);
      alert("เกิดข้อผิดพลาด: " + error.message);
    } finally {
      setPrinting(false);
      setJobProgress({ current: 0, total: 0 });
    }
  };

  const safeData = Array.isArray(dataTabelB) ? dataTabelB : [];

  return (
    <>
      <Space>
        <Tooltip title={schemaSelected ? "" : "กรุณาเลือกประเภทก่อน"}>
          <Select
            placeholder="เลือกทนาย"
            value={selectedLawyer}
            onChange={(val) => setSelectedLawyer(val)}
            options={lawyerOptions}
            disabled={printing || !schemaSelected}
            style={{ width: 120 }}
          />
        </Tooltip>
        <Button
          type="primary"
          onClick={handlePDF}
          disabled={printing || !schemaSelected || !selectedLawyer}
          danger
        >
          {printing
            ? `กำลังพิมพ์ ${jobProgress.current}/${jobProgress.total}`
            : `พิมพ์ PDF (${safeData.length} ใบ)`}
        </Button>
      </Space>
    </>
  );
}
export default PrintPDF;